// Translations for the app
export const translations = {
  pt: {
    // Navigation
    nav_home: 'Início',
    nav_clients: 'Clientes',
    nav_ppm: 'PPM',
    nav_catalogs: 'Catálogos',
    nav_documents: 'Documentos',
    nav_settings: 'Configurações',
    
    // Dashboard
    dashboard_title: 'Gestão de Merchandising',
    dashboard_clients: 'Clientes',
    dashboard_ppm: 'PPM',
    dashboard_catalogs: 'Catálogos',
    dashboard_documents: 'Documentos',
    dashboard_gresart_catalog: 'Catálogos Gresart',
    
    // Settings
    settings_title: 'Configurações',
    settings_subtitle: 'Personalize a aplicação',
    settings_security: 'Segurança',
    settings_security_desc: 'Proteja a Secção Privada com PIN',
    settings_pin_enabled: 'PIN Ativado',
    settings_pin_disabled: 'PIN Desativado',
    settings_change_pin: 'Alterar PIN',
    settings_set_pin: 'Definir PIN',
    settings_remove_pin: 'Remover PIN',
    settings_catalog: 'Catálogo Gresart',
    settings_catalog_desc: 'PDF que abre ao clicar em "Catálogo Gresart"',
    settings_catalog_custom: 'PDF personalizado carregado',
    settings_catalog_default: 'Usando catálogo padrão da web',
    settings_upload_catalog: 'Carregar Catálogo',
    settings_language: 'Idioma',
    settings_language_desc: 'Selecione o idioma da aplicação',
    settings_appearance: 'Aparência',
    settings_appearance_desc: 'Personalize o visual da aplicação',
    settings_theme_light: 'Modo Claro',
    settings_theme_dark: 'Modo Noturno',
    settings_data: 'Dados',
    settings_data_desc: 'Gerir dados da aplicação',
    settings_export: 'Exportar Dados',
    settings_export_desc: 'Descarregar todos os dados em JSON',
    settings_panel_sizes: 'Tamanhos de Painel',
    settings_panel_sizes_desc: 'Tamanhos disponíveis para painéis técnicos',
    settings_clear_cache: 'Limpar Cache',
    settings_clear_cache_desc: 'Limpar dados temporários',
    
    // Private Section
    private_title: 'Secção Privada',
    private_subtitle: 'Documentos confidenciais da empresa',
    private_enter_pin: 'Introduza o PIN',
    private_pin_placeholder: '••••',
    private_pin_error: 'PIN incorreto',
    private_unlock: 'Desbloquear',
    private_price_table: 'Tabela de Preços',
    private_reports: 'Relatórios',
    private_sales: 'Vendas',
    private_no_documents: 'Sem documentos nesta secção',
    private_add_hint: 'Clique em "Adicionar" para carregar um PDF',
    
    // Common
    common_add: 'Adicionar',
    common_cancel: 'Cancelar',
    common_save: 'Guardar',
    common_delete: 'Eliminar',
    common_edit: 'Editar',
    common_view: 'Ver',
    common_search: 'Pesquisar',
    common_loading: 'A carregar...',
    common_confirm_delete: 'Confirmar Eliminação',
    common_confirm_delete_msg: 'Tem certeza que deseja eliminar?',
    common_success: 'Sucesso',
    common_error: 'Erro',
    common_back: 'Voltar',
    
    // Additional PIN translations
    settings_pin_error_4digits: 'O PIN deve ter 4 dígitos',
    settings_pin_error_mismatch: 'Os PINs não coincidem',
    settings_pin_set_success: 'PIN definido com sucesso',
    settings_pin_changed_success: 'PIN alterado com sucesso',
    settings_pin_removed_success: 'PIN removido com sucesso',
    settings_pin_enter_new: 'Introduza novo PIN',
    settings_pin_enter_current: 'Introduza PIN atual',
    settings_pin_confirm: 'Confirme o PIN',
    settings_pin_next: 'Continuar',
    settings_pin_or_type: 'Ou introduza diretamente:',
    settings_catalog_uploaded: 'Catálogo carregado com sucesso',
    settings_catalog_removed: 'Catálogo removido',
    settings_export_success: 'Dados exportados com sucesso',
    settings_cache_cleared: 'Cache limpo com sucesso',
    private_lock: 'Bloquear',

    // Phase 4 additions
    nav_promocao: 'Promoção',
    nav_agenda: 'Agenda',
    nav_projetos: 'Projetos',
    nav_incidencias: 'Incidências',
    nav_reclamacoes: 'Reclamações',
    nav_catalog_merch: 'Catálogo Merchandising',
    nav_precos: 'Preços',
    nav_tabelas: 'Documentos',
    dashboard_hero_title: 'Gestão de Marketing e Vendas',
    dashboard_sales_analysis: 'Análise de Vendas',
    dashboard_rappel: 'Rappel',
    dashboard_statistics_ppm: 'Estatísticas PPM',
    client_tab_comercial: 'Comercial',
    client_tab_showroom: 'Showroom',
  },
  
  en: {
    // Navigation
    nav_home: 'Home',
    nav_clients: 'Clients',
    nav_ppm: 'PPM',
    nav_catalogs: 'Catalogs',
    nav_documents: 'Documents',
    nav_settings: 'Settings',
    
    // Dashboard
    dashboard_title: 'Merchandising Management',
    dashboard_clients: 'Clients',
    dashboard_ppm: 'PPM',
    dashboard_catalogs: 'Catalogs',
    dashboard_documents: 'Documents',
    dashboard_gresart_catalog: 'Gresart Catalogs',
    dashboard_private_section: 'Private Section',
    
    // Settings
    settings_title: 'Settings',
    settings_subtitle: 'Customize the application',
    settings_security: 'Security',
    settings_security_desc: 'Protect the Private Section with PIN',
    settings_pin_enabled: 'PIN Enabled',
    settings_pin_disabled: 'PIN Disabled',
    settings_change_pin: 'Change PIN',
    settings_set_pin: 'Set PIN',
    settings_remove_pin: 'Remove PIN',
    settings_catalog: 'Gresart Catalog',
    settings_catalog_desc: 'PDF that opens when clicking "Gresart Catalog"',
    settings_catalog_custom: 'Custom PDF uploaded',
    settings_catalog_default: 'Using default web catalog',
    settings_upload_catalog: 'Upload Catalog',
    settings_language: 'Language',
    settings_language_desc: 'Select the application language',
    settings_appearance: 'Appearance',
    settings_appearance_desc: 'Customize the app visual',
    settings_theme_light: 'Light Mode',
    settings_theme_dark: 'Dark Mode',
    settings_data: 'Data',
    settings_data_desc: 'Manage application data',
    settings_export: 'Export Data',
    settings_export_desc: 'Download all data as JSON',
    settings_panel_sizes: 'Panel Sizes',
    settings_panel_sizes_desc: 'Available sizes for technical panels',
    settings_clear_cache: 'Clear Cache',
    settings_clear_cache_desc: 'Clear temporary data',
    
    // Private Section
    private_title: 'Private Section',
    private_subtitle: 'Confidential company documents',
    private_enter_pin: 'Enter PIN',
    private_pin_placeholder: '••••',
    private_pin_error: 'Incorrect PIN',
    private_unlock: 'Unlock',
    private_price_table: 'Price Table',
    private_reports: 'Reports',
    private_sales: 'Sales',
    private_no_documents: 'No documents in this section',
    private_add_hint: 'Click "Add" to upload a PDF',
    
    // Common
    common_add: 'Add',
    common_cancel: 'Cancel',
    common_save: 'Save',
    common_delete: 'Delete',
    common_edit: 'Edit',
    common_view: 'View',
    common_search: 'Search',
    common_loading: 'Loading...',
    common_confirm_delete: 'Confirm Deletion',
    common_confirm_delete_msg: 'Are you sure you want to delete?',
    common_success: 'Success',
    common_error: 'Error',
    common_back: 'Back',
    
    // Additional PIN translations
    settings_pin_error_4digits: 'PIN must be 4 digits',
    settings_pin_error_mismatch: 'PINs do not match',
    settings_pin_set_success: 'PIN set successfully',
    settings_pin_changed_success: 'PIN changed successfully',
    settings_pin_removed_success: 'PIN removed successfully',
    settings_pin_enter_new: 'Enter new PIN',
    settings_pin_enter_current: 'Enter current PIN',
    settings_pin_confirm: 'Confirm PIN',
    settings_pin_next: 'Continue',
    settings_pin_or_type: 'Or type directly:',
    settings_catalog_uploaded: 'Catalog uploaded successfully',
    settings_catalog_removed: 'Catalog removed',
    settings_export_success: 'Data exported successfully',
    settings_cache_cleared: 'Cache cleared successfully',
    private_lock: 'Lock',

    // Phase 4 additions
    nav_promocao: 'Promotion',
    nav_agenda: 'Agenda',
    nav_projetos: 'Projects',
    nav_incidencias: 'Incidents',
    nav_reclamacoes: 'Complaints',
    nav_catalog_merch: 'Merchandising Catalog',
    nav_precos: 'Prices',
    nav_tabelas: 'Documents',
    dashboard_hero_title: 'Sales & Marketing Management',
    dashboard_sales_analysis: 'Sales Analysis',
    dashboard_rappel: 'Rappel',
    dashboard_statistics_ppm: 'PPM Statistics',
    client_tab_comercial: 'Commercial',
    client_tab_showroom: 'Showroom',
  },
  
  es: {
    // Navigation
    nav_home: 'Inicio',
    nav_clients: 'Clientes',
    nav_ppm: 'PPM',
    nav_catalogs: 'Catálogos',
    nav_documents: 'Documentos',
    nav_settings: 'Configuración',
    
    // Dashboard
    dashboard_title: 'Gestión de Merchandising',
    dashboard_clients: 'Clientes',
    dashboard_ppm: 'PPM',
    dashboard_catalogs: 'Catálogos',
    dashboard_documents: 'Documentos',
    dashboard_gresart_catalog: 'Catálogos Gresart',
    dashboard_private_section: 'Sección Privada',
    
    // Settings
    settings_title: 'Configuración',
    settings_subtitle: 'Personaliza la aplicación',
    settings_security: 'Seguridad',
    settings_security_desc: 'Protege la Sección Privada con PIN',
    settings_pin_enabled: 'PIN Activado',
    settings_pin_disabled: 'PIN Desactivado',
    settings_change_pin: 'Cambiar PIN',
    settings_set_pin: 'Definir PIN',
    settings_remove_pin: 'Eliminar PIN',
    settings_catalog: 'Catálogo Gresart',
    settings_catalog_desc: 'PDF que se abre al hacer clic en "Catálogo Gresart"',
    settings_catalog_custom: 'PDF personalizado cargado',
    settings_catalog_default: 'Usando catálogo predeterminado de la web',
    settings_upload_catalog: 'Cargar Catálogo',
    settings_language: 'Idioma',
    settings_language_desc: 'Selecciona el idioma de la aplicación',
    settings_appearance: 'Apariencia',
    settings_appearance_desc: 'Personaliza el aspecto de la aplicación',
    settings_theme_light: 'Modo Claro',
    settings_theme_dark: 'Modo Nocturno',
    settings_data: 'Datos',
    settings_data_desc: 'Gestionar datos de la aplicación',
    settings_export: 'Exportar Datos',
    settings_export_desc: 'Descargar todos los datos en JSON',
    settings_panel_sizes: 'Tamaños de Panel',
    settings_panel_sizes_desc: 'Tamaños disponibles para paneles técnicos',
    settings_clear_cache: 'Limpiar Caché',
    settings_clear_cache_desc: 'Limpiar datos temporales',
    
    // Private Section
    private_title: 'Sección Privada',
    private_subtitle: 'Documentos confidenciales de la empresa',
    private_enter_pin: 'Introduce el PIN',
    private_pin_placeholder: '••••',
    private_pin_error: 'PIN incorrecto',
    private_unlock: 'Desbloquear',
    private_price_table: 'Tabla de Precios',
    private_reports: 'Informes',
    private_sales: 'Ventas',
    private_no_documents: 'Sin documentos en esta sección',
    private_add_hint: 'Haz clic en "Añadir" para cargar un PDF',
    
    // Common
    common_add: 'Añadir',
    common_cancel: 'Cancelar',
    common_save: 'Guardar',
    common_delete: 'Eliminar',
    common_edit: 'Editar',
    common_view: 'Ver',
    common_search: 'Buscar',
    common_loading: 'Cargando...',
    common_confirm_delete: 'Confirmar Eliminación',
    common_confirm_delete_msg: '¿Estás seguro de que quieres eliminar?',
    common_success: 'Éxito',
    common_error: 'Error',
    common_back: 'Volver',
    
    // Additional PIN translations
    settings_pin_error_4digits: 'El PIN debe tener 4 dígitos',
    settings_pin_error_mismatch: 'Los PIN no coinciden',
    settings_pin_set_success: 'PIN establecido correctamente',
    settings_pin_changed_success: 'PIN cambiado correctamente',
    settings_pin_removed_success: 'PIN eliminado correctamente',
    settings_pin_enter_new: 'Introduce nuevo PIN',
    settings_pin_enter_current: 'Introduce PIN actual',
    settings_pin_confirm: 'Confirma el PIN',
    settings_pin_next: 'Continuar',
    settings_pin_or_type: 'O escribe directamente:',
    settings_catalog_uploaded: 'Catálogo cargado correctamente',
    settings_catalog_removed: 'Catálogo eliminado',
    settings_export_success: 'Datos exportados correctamente',
    settings_cache_cleared: 'Caché limpiada correctamente',
    private_lock: 'Bloquear',

    // Phase 4 additions
    nav_promocao: 'Promoción',
    nav_agenda: 'Agenda',
    nav_projetos: 'Proyectos',
    nav_incidencias: 'Incidencias',
    nav_reclamacoes: 'Reclamaciones',
    nav_catalog_merch: 'Catálogo de Merchandising',
    nav_precos: 'Precios',
    nav_tabelas: 'Documentos',
    dashboard_hero_title: 'Gestión de Marketing y Ventas',
    dashboard_sales_analysis: 'Análisis de Ventas',
    dashboard_rappel: 'Rappel',
    dashboard_statistics_ppm: 'Estadísticas PPM',
    client_tab_comercial: 'Comercial',
    client_tab_showroom: 'Showroom',
  },
  
  fr: {
    // Navigation
    nav_home: 'Accueil',
    nav_clients: 'Clients',
    nav_ppm: 'PPM',
    nav_catalogs: 'Catalogues',
    nav_documents: 'Documents',
    nav_settings: 'Paramètres',
    
    // Dashboard
    dashboard_title: 'Gestion du Merchandising',
    dashboard_clients: 'Clients',
    dashboard_ppm: 'PPM',
    dashboard_catalogs: 'Catalogues',
    dashboard_documents: 'Documents',
    dashboard_gresart_catalog: 'Catalogues Gresart',
    dashboard_private_section: 'Section Privée',
    
    // Settings
    settings_title: 'Paramètres',
    settings_subtitle: 'Personnalisez l\'application',
    settings_security: 'Sécurité',
    settings_security_desc: 'Protégez la Section Privée avec un PIN',
    settings_pin_enabled: 'PIN Activé',
    settings_pin_disabled: 'PIN Désactivé',
    settings_change_pin: 'Changer le PIN',
    settings_set_pin: 'Définir le PIN',
    settings_remove_pin: 'Supprimer le PIN',
    settings_catalog: 'Catalogue Gresart',
    settings_catalog_desc: 'PDF qui s\'ouvre en cliquant sur "Catalogue Gresart"',
    settings_catalog_custom: 'PDF personnalisé téléchargé',
    settings_catalog_default: 'Utilisation du catalogue web par défaut',
    settings_upload_catalog: 'Télécharger le Catalogue',
    settings_language: 'Langue',
    settings_language_desc: 'Sélectionnez la langue de l\'application',
    settings_appearance: 'Apparence',
    settings_appearance_desc: 'Personnalisez l\'aspect de l\'application',
    settings_theme_light: 'Mode Clair',
    settings_theme_dark: 'Mode Sombre',
    settings_data: 'Données',
    settings_data_desc: 'Gérer les données de l\'application',
    settings_export: 'Exporter les Données',
    settings_export_desc: 'Télécharger toutes les données en JSON',
    settings_panel_sizes: 'Tailles de Panneau',
    settings_panel_sizes_desc: 'Tailles disponibles pour les panneaux techniques',
    settings_clear_cache: 'Vider le Cache',
    settings_clear_cache_desc: 'Effacer les données temporaires',
    
    // Private Section
    private_title: 'Section Privée',
    private_subtitle: 'Documents confidentiels de l\'entreprise',
    private_enter_pin: 'Entrez le PIN',
    private_pin_placeholder: '••••',
    private_pin_error: 'PIN incorrect',
    private_unlock: 'Déverrouiller',
    private_price_table: 'Tableau des Prix',
    private_reports: 'Rapports',
    private_sales: 'Ventes',
    private_no_documents: 'Aucun document dans cette section',
    private_add_hint: 'Cliquez sur "Ajouter" pour télécharger un PDF',
    
    // Common
    common_add: 'Ajouter',
    common_cancel: 'Annuler',
    common_save: 'Enregistrer',
    common_delete: 'Supprimer',
    common_edit: 'Modifier',
    common_view: 'Voir',
    common_search: 'Rechercher',
    common_loading: 'Chargement...',
    common_confirm_delete: 'Confirmer la Suppression',
    common_confirm_delete_msg: 'Êtes-vous sûr de vouloir supprimer?',
    common_success: 'Succès',
    common_error: 'Erreur',
    common_back: 'Retour',
    
    // Additional PIN translations
    settings_pin_error_4digits: 'Le PIN doit comporter 4 chiffres',
    settings_pin_error_mismatch: 'Les PIN ne correspondent pas',
    settings_pin_set_success: 'PIN défini avec succès',
    settings_pin_changed_success: 'PIN modifié avec succès',
    settings_pin_removed_success: 'PIN supprimé avec succès',
    settings_pin_enter_new: 'Entrez un nouveau PIN',
    settings_pin_enter_current: 'Entrez le PIN actuel',
    settings_pin_confirm: 'Confirmez le PIN',
    settings_pin_next: 'Continuer',
    settings_pin_or_type: 'Ou tapez directement:',
    settings_catalog_uploaded: 'Catalogue téléchargé avec succès',
    settings_catalog_removed: 'Catalogue supprimé',
    settings_export_success: 'Données exportées avec succès',
    settings_cache_cleared: 'Cache vidé avec succès',
    private_lock: 'Verrouiller',

    // Phase 4 additions
    nav_promocao: 'Promotion',
    nav_agenda: 'Agenda',
    nav_projetos: 'Projets',
    nav_incidencias: 'Incidents',
    nav_reclamacoes: 'Réclamations',
    nav_catalog_merch: 'Catalogue Merchandising',
    nav_precos: 'Prix',
    nav_tabelas: 'Documents',
    dashboard_hero_title: 'Gestion Marketing et Ventes',
    dashboard_sales_analysis: 'Analyse des Ventes',
    dashboard_rappel: 'Rappel',
    dashboard_statistics_ppm: 'Statistiques PPM',
    client_tab_comercial: 'Commercial',
    client_tab_showroom: 'Showroom',
  },
  
  it: {
    // Navigation
    nav_home: 'Home',
    nav_clients: 'Clienti',
    nav_ppm: 'PPM',
    nav_catalogs: 'Cataloghi',
    nav_documents: 'Documenti',
    nav_settings: 'Impostazioni',
    
    // Dashboard
    dashboard_title: 'Gestione Merchandising',
    dashboard_clients: 'Clienti',
    dashboard_ppm: 'PPM',
    dashboard_catalogs: 'Cataloghi',
    dashboard_documents: 'Documenti',
    dashboard_gresart_catalog: 'Cataloghi Gresart',
    dashboard_private_section: 'Sezione Privata',
    
    // Settings
    settings_title: 'Impostazioni',
    settings_subtitle: 'Personalizza l\'applicazione',
    settings_security: 'Sicurezza',
    settings_security_desc: 'Proteggi la Sezione Privata con PIN',
    settings_pin_enabled: 'PIN Attivato',
    settings_pin_disabled: 'PIN Disattivato',
    settings_change_pin: 'Cambia PIN',
    settings_set_pin: 'Imposta PIN',
    settings_remove_pin: 'Rimuovi PIN',
    settings_catalog: 'Catalogo Gresart',
    settings_catalog_desc: 'PDF che si apre cliccando su "Catalogo Gresart"',
    settings_catalog_custom: 'PDF personalizzato caricato',
    settings_catalog_default: 'Utilizzo del catalogo web predefinito',
    settings_upload_catalog: 'Carica Catalogo',
    settings_language: 'Lingua',
    settings_language_desc: 'Seleziona la lingua dell\'applicazione',
    settings_appearance: 'Aspetto',
    settings_appearance_desc: 'Personalizza l\'aspetto dell\'applicazione',
    settings_theme_light: 'Modalità Chiara',
    settings_theme_dark: 'Modalità Scura',
    settings_data: 'Dati',
    settings_data_desc: 'Gestisci i dati dell\'applicazione',
    settings_export: 'Esporta Dati',
    settings_export_desc: 'Scarica tutti i dati in JSON',
    settings_panel_sizes: 'Dimensioni Pannello',
    settings_panel_sizes_desc: 'Dimensioni disponibili per i pannelli tecnici',
    settings_clear_cache: 'Svuota Cache',
    settings_clear_cache_desc: 'Cancella i dati temporanei',
    
    // Private Section
    private_title: 'Sezione Privata',
    private_subtitle: 'Documenti riservati dell\'azienda',
    private_enter_pin: 'Inserisci il PIN',
    private_pin_placeholder: '••••',
    private_pin_error: 'PIN errato',
    private_unlock: 'Sblocca',
    private_price_table: 'Listino Prezzi',
    private_reports: 'Rapporti',
    private_sales: 'Vendite',
    private_no_documents: 'Nessun documento in questa sezione',
    private_add_hint: 'Clicca su "Aggiungi" per caricare un PDF',
    
    // Common
    common_add: 'Aggiungi',
    common_cancel: 'Annulla',
    common_save: 'Salva',
    common_delete: 'Elimina',
    common_edit: 'Modifica',
    common_view: 'Vedi',
    common_search: 'Cerca',
    common_loading: 'Caricamento...',
    common_confirm_delete: 'Conferma Eliminazione',
    common_confirm_delete_msg: 'Sei sicuro di voler eliminare?',
    common_success: 'Successo',
    common_error: 'Errore',
    common_back: 'Indietro',
    
    // Additional PIN translations
    settings_pin_error_4digits: 'Il PIN deve avere 4 cifre',
    settings_pin_error_mismatch: 'I PIN non corrispondono',
    settings_pin_set_success: 'PIN impostato con successo',
    settings_pin_changed_success: 'PIN modificato con successo',
    settings_pin_removed_success: 'PIN rimosso con successo',
    settings_pin_enter_new: 'Inserisci nuovo PIN',
    settings_pin_enter_current: 'Inserisci PIN attuale',
    settings_pin_confirm: 'Conferma il PIN',
    settings_pin_next: 'Continua',
    settings_pin_or_type: 'Oppure digita direttamente:',
    settings_catalog_uploaded: 'Catalogo caricato con successo',
    settings_catalog_removed: 'Catalogo rimosso',
    settings_export_success: 'Dati esportati con successo',
    settings_cache_cleared: 'Cache svuotata con successo',
    private_lock: 'Blocca',

    // Phase 4 additions
    nav_promocao: 'Promozione',
    nav_agenda: 'Agenda',
    nav_projetos: 'Progetti',
    nav_incidencias: 'Incidenze',
    nav_reclamacoes: 'Reclami',
    nav_catalog_merch: 'Catalogo Merchandising',
    nav_precos: 'Prezzi',
    nav_tabelas: 'Documenti',
    dashboard_hero_title: 'Gestione Marketing e Vendite',
    dashboard_sales_analysis: 'Analisi delle Vendite',
    dashboard_rappel: 'Rappel',
    dashboard_statistics_ppm: 'Statistiche PPM',
    client_tab_comercial: 'Commerciale',
    client_tab_showroom: 'Showroom',
  },
};

export const languages = [
  { code: 'pt', name: 'Português', flag: 'PT' },
  { code: 'en', name: 'English', flag: 'IG' },
  { code: 'es', name: 'Español', flag: 'ES' },
  { code: 'fr', name: 'Français', flag: 'FR' },
  { code: 'it', name: 'Italiano', flag: 'IT' },
];

export function useTranslation() {
  const getLanguage = () => {
    const saved = localStorage.getItem('gresart_settings');
    if (saved) {
      const settings = JSON.parse(saved);
      return settings.language || 'pt';
    }
    return 'pt';
  };

  const t = (key) => {
    const lang = getLanguage();
    return translations[lang]?.[key] || translations['pt']?.[key] || key;
  };

  return { t, getLanguage };
}
